import styled from 'styled-components/macro'
import { TextContainer } from './container'
import { mq } from 'styles/mq'

export const Quote = styled.span`
  font-family: 'IBM Plex Sans', sans-serif;
  font-weight: 600;
  font-style: italic;
`

export const Title = styled.h2<{ 'data-menu-title'?: string }>`
  position: relative;
  text-align: left;

  ${TextContainer} & {
    width: max-content;
    max-width: 100%;
  }
`

export const Section = styled.section`
  position: relative;
  margin: 3rem 0;

  ${mq.medium} {
    margin: 5rem 0;
  }

  ${mq.large} {
    margin: 8rem 0;
  }
`
